// Import source styles
import "../scss/app.scss";

// Load External Libraries
import './bootstrap';
import AOS from 'aos';
import { Fancybox } from "@fancyapps/ui";

// Local imports
import { validate } from './modules/_validate.mjs';
import { Disclosure } from "./modules/_disclosure.mjs";
import { offcanvas } from "./modules/_offcanvas.mjs";
import { headerscroll } from "./modules/_header.mjs";
import {doelgroepenSlider, tevredenheidsonderzoekSlider} from "./modules/_carousels.mjs";
import { Accordion } from "./modules/_accordion.mjs";
import { scrible } from "./modules/_header.mjs";
import { Sitesearch } from "./modules/_search.mjs";


document.addEventListener("DOMContentLoaded", function () {
    AOS.init({startEvent: 'load', disable: 'mobile'});
    validate();
    offcanvas();
    headerscroll();
    doelgroepenSlider();
    tevredenheidsonderzoekSlider();
    scrible();

    const disclosure = new Disclosure();
    const accordion = new Accordion();
    const sitesearch = new Sitesearch();

    const truncateButtons = document.querySelectorAll('.expand-truncate');
    if (truncateButtons) {
        truncateButtons.forEach(Button => {
            Button.addEventListener('click', () =>  {
                let text = Button.parentElement.previousElementSibling;
                text.classList.remove('truncate');
            });
        });
    }

    const fancyboxButtons = document.querySelectorAll('.close-current-fancybox');
    if (fancyboxButtons) {
        fancyboxButtons.forEach(Button => {
            Button.addEventListener('click', () =>  {
                Fancybox.close();
            });
        });
    }

});

